
export default {
  name: 'VideoBg',
}
